<template>
  <el-form
      ref="form"
      :model="form">
    <el-radio-group
        v-model="form.bidType">
      <el-radio :label="AdBidTypeEnum.default">
        默认竞价
        <div class="bid-type-help">适用于您的广告组的所有关键词，除非您为特定关键词设置不同的竞价</div>
      </el-radio>
      <el-form-item
          v-if="AdBidTypeEnum.default === form.bidType"
          prop="defaultBid"
          :rules="[
            { required: true, message: '请输入默认竞价', trigger: ['blur', 'change'] },
            $gjReRule(RE.num(2), '请输入两位小数正数'),
            $gjMinRule(0.02, '应大于等于0.02')
          ]"
          class="bid-form-item">
        <span class="required-icon">*</span>
        <gj-input
            v-model="form.defaultBid"
            width="150px">
          <template #prepend>{{adStore.SP.currencySymbol}}</template>
        </gj-input>
      </el-form-item>
      <el-radio
          :label="AdBidTypeEnum.targetGroup"
          :class="{'target-group-bid': AdBidTypeEnum.targetGroup === form.bidType}">
        投放组竞价
        <div class="bid-type-help bid-type-help2">使用多种策略将您的广告与寻找您产品的购物者进行匹配</div>
      </el-radio>
      <div v-if="AdBidTypeEnum.targetGroup === form.bidType" class="table-container">
        <gj-table
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :data="form.items"
            stripe
            :columns="columns">
          <template v-slot:targetGroup="{ row, index }">
            <el-form-item
                :prop="`items.${index}.status`"
                class="gj-table-item">
              <gj-switch
                  v-model="form.items[index].status"
                  size="small"
              ></gj-switch>
              <span style="font-size: 12px; margin: 0 8px;">{{row.text}}</span>
              <gj-help>{{row.help}}</gj-help>
            </el-form-item>
          </template>
          <template v-slot:suggestBid>
            --
          </template>
          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjReRule(RE.num(2), '请输入两位小数正数'),
                  $gjMinRule(0.02, '应大于等于0.02')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  width="150px">
                <template #prepend>{{adStore.SP.currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
      </div>
    </el-radio-group>
  </el-form>
</template>

<script>
  import {formMixin, formRuleMixin} from "../../../../../../../../minxins";
  import {AdBidTypeEnum} from "../../../../../common/enum";
  import {adStoreMixin} from "../../../../../common/mixin";
  import {targetGroupType} from "../../../../../common/options";

  export default {
    name: "app-bid-picker",
    mixins: [formMixin, adStoreMixin, formRuleMixin],
    created() {
      this.form.items = targetGroupType.map(e => ({
        ...e,
        status: true,
        bid: this.adStore.SP.defaultBid
      }));
    },
    data() {
      return {
        AdBidTypeEnum: AdBidTypeEnum,
        columns: [
          {id: 'targetGroup', header: '投放组', field: 'slot:targetGroup', width: '200px'},
          {id: 'suggestBid', header: '建议竞价', field: 'slot:suggestBid', width: '200px'},
          {id: 'bid', header: '竞价', field: 'slot:bid', width: '200px', required: true},
        ]
      }
    },
    methods: {
      formValidate() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            valid ? resolve() : reject()
          });
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "bid-picker";
  
  .required-icon {
    font-size: 20px;
    color: #F56C6C;
    margin-right: 10px;
    vertical-align: middle;
  }

  /deep/ .bid-form-item .el-form-item__error {
    margin-left: 18px;
  }
  .bid-type-help2{
    margin-bottom: 8px;
  }
  .table-container{
    border: 1px solid #d9d9d9;
    // padding-bottom: 8px;
  }

  /deep/.vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 58px !important;
      }
    }
  }
</style>
